const TOKENS = Object.freeze({
    BORDER_RADIUS: '4px',
    COLORS_SELLSY_GRAYSCALE_100_ALPHA100: '#111111',
    COLORS_SELLSY_GRAYSCALE_40: '#ccccd1',
    COLORS_SELLSY_BRAND_PRIMARY_50_ALPHA100: '#4868FD',
    COLORS_COMMON_BACKGROUND_ALERT_DEFAULT: '#ff6060',
    COLORS_COMMON_BACKGROUND_WARNING_DEFAULT: '#f6c243',
    COLORS_COMMON_BACKGROUND_SUCCESS_DEFAULT: '#39CF86',
    COLORS_SELLSY_GRAYSCALE_WHITE_ALPHA100: '#FFFFFF',
});

export const themeConfig = {
    root: {
        // COLORS
        primaryColor: TOKENS.COLORS_SELLSY_BRAND_PRIMARY_50_ALPHA100,
        actionColor: TOKENS.COLORS_SELLSY_BRAND_PRIMARY_50_ALPHA100,
        dangerColor: TOKENS.COLORS_COMMON_BACKGROUND_ALERT_DEFAULT,
        warningColor: TOKENS.COLORS_COMMON_BACKGROUND_WARNING_DEFAULT,
        successColor: TOKENS.COLORS_COMMON_BACKGROUND_SUCCESS_DEFAULT,
        borderColor: TOKENS.COLORS_SELLSY_GRAYSCALE_40,

        // BUTTONS
        buttonBorderRadius: TOKENS.BORDER_RADIUS,

        // CHECKBOXES
        checkboxBorderColor: TOKENS.COLORS_SELLSY_GRAYSCALE_40,
        checkboxBorderRadius: TOKENS.BORDER_RADIUS,

        // SELECT + DROPDOWN
        interactiveBorderRadius: TOKENS.BORDER_RADIUS,

        //MODAL
        modalBorderRadius: TOKENS.BORDER_RADIUS,

        //PILL
        pillBorderRadius: TOKENS.BORDER_RADIUS,

        //POPOVER
        popoverBackgroundColor: TOKENS.COLORS_SELLSY_GRAYSCALE_100_ALPHA100,
        popoverBorderRadius: TOKENS.BORDER_RADIUS,

        //TOOLTIP
        tooltipBackgroundColor: TOKENS.COLORS_SELLSY_GRAYSCALE_100_ALPHA100,
    },
    table: {
        fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        column: {
            header: {
                backgroundColor: TOKENS.COLORS_SELLSY_GRAYSCALE_WHITE_ALPHA100,
                color: TOKENS.COLORS_SELLSY_GRAYSCALE_100_ALPHA100,
            },
        },
        // CHECKBOXES
        indexColumn: {
            backgroundColor: TOKENS.COLORS_SELLSY_GRAYSCALE_WHITE_ALPHA100,
            color: TOKENS.COLORS_SELLSY_GRAYSCALE_100_ALPHA100,
        },
        // BUTTONS
        buttons: {
            iconColor: TOKENS.COLORS_SELLSY_GRAYSCALE_100_ALPHA100,
        },
    },
};
